export const newPetFeatureKey = 'newPet';
